import { TFunction } from "i18n";

export interface IYearOption {
  // miss consistency in naming: 'name' vs 'label' in components formik and self written,
  // have to keep it for backward compatibility
  name: string;
  label: string;
  value: number;
}

export function getPlayingAgeLabel(age: number, t: TFunction): string {
  if (age === 0) {
    return t("common:label.options.playingAge.month", { count: 6 });
  }

  return t("common:label.options.playingAge.year", { count: age });
}

export interface IGetAgeOptionsParams {
  t: TFunction;
  minAge?: number;
  maxAge?: number;
  selectedFrom?: number | null;
  selectedTo?: number | null;
}

export default function getAgeRangeOptions({
  t,
  minAge = 0,
  maxAge = 99,
  selectedFrom = null,
  selectedTo = null,
}: IGetAgeOptionsParams): {
  yearsFrom: IYearOption[];
  yearsTo: IYearOption[];
} {
  const allAges = Array.from(
    { length: maxAge - minAge + 1 },
    (_, i) => i + minAge
  );

  const getYearOption = (age: number) => {
    const label = getPlayingAgeLabel(age, t);

    return {
      label,
      name: label,
      value: age,
    };
  };

  const yearsFrom = allAges
    .filter((age) => selectedTo === null || age <= selectedTo)
    .map(getYearOption);

  const yearsTo = allAges
    .filter((age) => selectedFrom === null || age >= selectedFrom)
    .map(getYearOption);

  return { yearsFrom, yearsTo };
}
